<div class="offcanvas-content activities-assign-panel" *ngIf="formData">
    <div class="d-flex justify-content-between align-items-center mb-5">
        <div class="d-flex">
            <div class="panel-nav_icon d-inline-flex">
                <button class="btn" style="padding-left: 0;" (click)="closing()">
                    <i class="fa fa-arrow-left"></i>
                </button>
            </div>
            <div class="panel-nav_title d-inline-flex align-self-center">
                {{ l('DraftForms') }}
            </div>
        </div>

        <div class="d-flex">
            <div class="btn-group dropdown" dropdown *ngIf="isGranted('Pages.ActivityDays.Create')">
                <button class="dropdown-toggle btn btn-sm" dropdownToggle title="Clone">
                    <i class="fa fa-copy"></i>
                </button>
                <ul class="dropdown-menu" *dropdownMenu style="margin-left: -60px">
                    <li>
                        <button class="dropdown-item" (click)="cloneForm(false)">
                            <span>{{ l('CloneNameOnly') }}</span>
                        </button>
                    </li>
                    <li>
                        <button class="dropdown-item" (click)="cloneForm(true)">
                            <span>{{ l('CloneWithData') }}</span>
                        </button>
                    </li>
                </ul>
            </div>
            <div class="btn-group dropdown" dropdown *ngIf="isGranted('Pages.ActivityDays.Delete')">
                <button class="dropdown-toggle btn btn-sm" dropdownToggle>
                    <i class="fa fa-trash"></i>
                </button>
                <ul class="dropdown-menu" *dropdownMenu style="margin-left: -60px">
                    <li>
                        <button class="dropdown-item" (click)="deleteDay()">
                            <span>{{ l('Day') }}</span>
                        </button>
                    </li>
                    <li>
                        <button class="dropdown-item" disabled="true">
                            {{ l('AllDays') }}
                        </button>
                    </li>
                </ul>
            </div>

        </div>
    </div>
    <div class="navi navi-spacer-x-0 p-0 mt-10">
        <div class="padding-right">
            <div class="complete-forms-row">
                <div class="cell">
                    <div class="form-group">
                        <label for="FormName">{{l("FormName")}}
                        </label>
                        <input class="form-control" [value]="formDef ? formDef.name : ''"  [disabled]="true">
                    </div>
                </div>
                <div class="cell">
                    <div class="form-group">
                        <label for="ActivityDay">{{l("ActivityDay")}}
                        </label>
                        <div>
                            <mat-form-field appearance="none">
                                <input matInput [matDatepicker]="datepicker" name="activityDate" [(ngModel)]="formData.activityDate" >
                                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                                <mat-datepicker #datepicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="cell">
                    <div class="form-group">
                        <label for="Creator">{{ l('Creator') }}</label>
                        <input class="form-control" [disabled]="true" [value]="formData.createdByUser ? formData.createdByUser.firstName +
                                ' ' + formData.createdByUser.lastName : 'Allo admin'">
                    </div>
                </div>

            </div>
            <div class="form-group">
                <label for="ActivityName">{{l("ActivityDescription")}}*
                </label>
                <textarea id="ActivityName" rows="3" [ngClass]="{'edited':formData.activityName}" name="activityName" class="form-control edited" [(ngModel)]="formData.activityName" maxlength="256"></textarea>
            </div>
            <div class="panel-forms">
                <form [formGroup]="form">
                    <div *ngFor="let control of formDef?.fields">
                        <div  class="forms-control" *ngIf="control.isActive">
                            <app-control-host isReadOnly="false" [form]="form" [control]="control" [createdBy]="formData.createdBy" (blur)="onSubmit('isAutoSave')">
                            </app-control-host>
                        </div>
                    </div>
                </form>
            </div>
            <div class="mt-10 pb-20">
                <button class="mb-3 btn btn-xs btn-default btn-primary button-class" [disabled]="!this.form.valid" (click)="this.form.valid && onSubmit()">
                    {{ l('Submit') }}
                </button>
                <button class="mb-3 btn btn-xs btn-default btn-secondary button-class" (click)="closing()">
                    {{ l('Cancel') }}
                </button>
            </div>
        </div>
    </div>
</div>

<app-clone-activities-modal #cloneActivityModal (afterActivityCloned)="afterClone()">
</app-clone-activities-modal>
